import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { FeaturedProduct } from "@/components/FeaturedProduct";
import { Manifesto } from "@/components/Manifesto";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { BagReminder } from "@/components/BagReminder";
import { CartProvider } from "@/context/CartContext";
import CollectionPage from "@/pages/CollectionPage";
import LookbookPage from "@/pages/LookbookPage";
import ProductPage from "@/pages/ProductPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

const Home = () => (
  <main>
    <Nav />
    <Hero />
    <FeaturedProduct />
    <Manifesto />
    <EditorialMarquee />
    <Footer />
  </main>
);

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => lenis?.scrollTo(hash, { offset: -80, duration: 1.6 }), 150);
      return () => clearTimeout(t);
    }
    lenis?.scrollTo(0, { immediate: true });
  }, [pathname, hash, lenis]);
  return null;
};

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.08, wheelMultiplier: 0.9 }}>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <CartDrawer />
            <BagReminder />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/collection" element={<CollectionPage />} />
              <Route path="/lookbook" element={<LookbookPage />} />
              <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </ReactLenis>
    </div>
  );
}

export default App;
